
import Vue from 'vue'
import Alert from 'vux/src/components/alert/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import qs from 'qs'
import Api from '@/libs/api'

export default {
components: {
XInput,
XButton,
Group,
Cell,
Alert
},
data() {
return {
loginCode: '',
openid: '',
promotionID: 0,
userName: '',
userMobile: '',
veriCode: '',
veriCodeContent: '发送验证码',
veriCodeTotalTime: 60,
userAddress: '',
remark: '',
promotion: '',
flgVeriCode: true,
disableVeriCode: false
}
},
mounted() {
this.promotionID = Api.getQueryStringByName('id')
let code = Api.getQueryStringByName('code')
if (!code) {
code = Api.getQueryStringByName('login_token')
}
this.loginCode = code
let that = this
let paramsPromotion = {
promotion_id: this.promotionID
}
Api.http.get(Api.url.getPromotion + '?' + qs.stringify(paramsPromotion)).then(function(result) {
if (result.code === 0) {
that.promotion = result.promotion
document.title = result.title
}
})
let params = {
code: code
}
Api.http.post(Api.url.login, params).then(function(result) {
if (result.code === 0) {
that.$store.commit('changeMemberToken', result.member_token)
that.openid = result.openid
that.userName = result.member_truename
that.userMobile = result.member_mobile
for (var i = 0; i < result.address_list.length; i++) {
let address = result.address_list[i]
if (address.is_default === 1) {
that.userAddress = address.address
break
}
}
that.flgVeriCode = false
} else {
that.openid = result.openid
that.flgVeriCode = true
}
})
},

methods: {
countDown() {
this.veriCodeContent = this.veriCodeTotalTime + '秒后重试'
this.disableVeriCode = true
let clock = window.setInterval(() => {
this.veriCodeTotalTime--
this.veriCodeContent = this.veriCodeTotalTime + '秒后重试'
if (this.veriCodeTotalTime < 0) {
window.clearInterval(clock)
this.veriCodeContent = '发送验证码'
this.veriCodeTotalTime = 60
this.disableVeriCode = false
}
}, 1000)
},
handlVeriCode() {
let err = ''
if (!this.userMobile) {
err = '手机号码必须填写'
}
if (err) {
Vue.$vux.toast.show({
text: err,
position: 'middle',
type: 'warn'
})
return
}
let params = {
login_code: this.loginCode,
phone: this.userMobile
}
let that = this
Api.http
.post(Api.url.sendVeriCode, params)
.then(function(result) {
if (result.code === 0) {
that.countDown()
Vue.$vux.toast.show({
text: '验证码发送成功',
position: 'middle',
type: 'success'
})
} else {
Vue.$vux.alert.show({
title: '魔猴网 - 错误提示',
content: result.msg
})
}
})
.catch(function(message) {})
},
handleSubmit() {
let err = ''
if (!this.userName) {
err = '用户姓名必须填写'
} else if (!this.userMobile) {
err = '手机号码必须填写'
} else if (!this.userAddress) {
err = '收货地址必须填写'
} else if (this.flgVeriCode && !this.veriCode) {
err = '请输入验证码'
}
if (err) {
Vue.$vux.toast.show({
text: err,
position: 'middle',
type: 'warn'
})
return
}
let paramsInfo = {
member_token: this.$store.state.member_token,
openid: this.openid,
user_name: this.userName,
user_mobile: this.userMobile,
vericode: this.veriCode,
user_address: this.userAddress,
remark: this.remark
}
Api.http
.post(Api.url.submitPromotionInfo + '?promotion_id=' + this.promotionID, paramsInfo)
.then(function(result) {
if (result.code === 0) {
Vue.$vux.toast.show({
text: '领取信息提交成功',
position: 'middle',
type: 'success'
})
} else {
Vue.$vux.alert.show({
title: '魔猴网 - 错误提示',
content: result.msg
})
}
})
.catch(function(message) {})
}
}
}



// WEBPACK FOOTER //
// ./src/components/Promotion.vue